<template>
  <nav>
    <UtilsHeadline
      v-if="!route.meta.embedded"
      class="mb-s"
      :level="1"
      :text="$t('dbc-head-profile')"
    />
    <Tabs v-bind="tabsPassThrough">
      <TabList v-bind="tabListPassThrough">
        <SideMenuTab
          :title="$t('dbc-personal-data')"
          :route="usePagePath('data')!"
          class="rounded mt-xs mb-xs"
          icon="dbc-icon-account"
          value="3"
        />
        <SideMenuTab
          v-if="!route.meta.embedded"
          :title="$t('dbc-label-contract-tariff')"
          :route="usePagePath('tariff')!"
          class="rounded-t mb-[2px]"
          icon="dbc-icon-price"
          value="4"
        />
        <SideMenuTab
          v-if="!route.meta.embedded"
          :title="$t('dbc-contract')"
          :route="usePagePath('contract')!"
          class="rounded-b mb-xs"
          icon="dbc-icon-contract"
          value="5"
        />
        <SideMenuTab
          v-if="!route.meta.embedded"
          :title="$t('dbc-contract-credit')"
          :subtitle="totalCredits"
          :route="usePagePath('credit')!"
          class="rounded-t mb-[2px]"
          icon="dbc-icon-credit"
          value="1"
        />
        <SideMenuTab
          v-if="tariff?.paymentMethods?.length > 0"
          :title="$t('dbc-label-payment-method')"
          :route="usePagePath('payment')!"
          class="rounded-b"
          icon="dbc-icon-payment"
          value="2"
        />
        <SideMenuTabLogout v-if="!route.meta.embedded" class="rounded mt-xs" />
      </TabList>
    </Tabs>
  </nav>
</template>

<script setup lang="ts">
import Tabs from 'primevue/tabs'
import TabList from 'primevue/tablist'
import { useCustomerStore } from '../../stores/customer'

const route = useRoute()

const customerStore = useCustomerStore()
const { totalCredits, tariff } = storeToRefs(customerStore)

const tabsPassThrough = {
  pt: {
    root: {
      class: 'w-[343px] min-w[343px] max-tablet:w-full max-tablet:min-w-full',
    },
  },
}

const tabListPassThrough = {
  pt: {
    tabs: {
      class: 'flex flex-col',
      'aria-orientation': 'vertical',
    },
  },
}
</script>
